import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1150px;
  margin: 0 auto;
  border: ${({ theme }) => `1px solid ${theme.borders.gray}`};
`;
